import { atom } from "recoil";

export const currentAlertTab = atom<number>({
  key: "currentAlertTab",
  default: 0,
});
